import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { AdminState } from './types';

export const useAdminState = (): AdminState => useSelector((state: RootState) => state.admin, shallowEqual);

export default useAdminState;
